export default __webpack_public_path__ + "c0938abb630968b9fc0a0cc95d8d0d6f.svg";